// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8720) return "static/chunks/8720-5f65033c1639b71d.js";
	if (chunkId === 2534) return "static/chunks/2534-73d9b7484b540bea.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"717":"0ecd611f1cca3bdc","1646":"314724838722bc18","1891":"d92bff04725fc3f1","2482":"a215fba6678c32c9","3757":"e89a061476376447","4634":"625d86d2954bde3c","5139":"3af505ae0c727fe9","8131":"2ea8d43f29467ced","8352":"335add586a748bbe","8456":"91c2a54d78e7d593","8572":"495d85bc78c998ed","8870":"2b44db1e2b622880"}[chunkId] + ".js";
};